if (SERVER) {
  require("../server/setupEnv").default();
}

import getClientConfigValue from "../client/getClientConfigValue";
import { config as clientConfig } from "./client";

const config = {
  ...clientConfig,
  api: {
    product: {
      search: {
        timeout: SERVER
          ? parseInt(process.env.SEARCH_API_TIMEOUT)
          : parseInt(getClientConfigValue("SEARCH_API_TIMEOUT")) || 5000,
        retries:
          (SERVER
            ? process.env.SEARCH_API_RETRIES
            : getClientConfigValue("SEARCH_API_RETRIES")) || 0,
        search: "v2/",
        categories: "v2/categories",
        recommendations: "v2/recommendations",
        suggestions: "v2/suggestions",
        pageSize: 72
      }
    },
    facet: {
      path: "/product/facet/v1/enrichments/",
      timeout: SERVER
        ? null
        : parseInt(getClientConfigValue("FACET_API_TIMEOUT")) || 5000
    },
    category: {
      path: "/product/category/v1/categories/",
      timeout:
        (SERVER
          ? process.env.CATEGORY_API_TIMEOUT
          : getClientConfigValue("CATEGORY_API_TIMEOUT")) || 5000,
      details: "/details"
    },
    navigation: {
      baseUrl: process.env.NAVIGATION_API_HOSTNAME + "/navigation/",
      timeout:
        (SERVER
          ? process.env.NAVIGATION_API_TIMEOUT
          : getClientConfigValue("NAVIGATION_API_TIMEOUT")) || 5000,
      brands: "v2/tree/brands"
    },
    savedLists: {
      timeout:
        (SERVER
          ? null
          : parseInt(getClientConfigValue("SAVEDLISTS_API_TIMEOUT"))) || 7000
    },
    ...(SERVER
      ? {
          keepAlive: {
            freeSocketTimeout: process.env.API_KEEP_ALIVE_FREE_SOCKET_TIMEOUT,
            inactiveSocketTimeout:
              process.env.API_KEEP_ALIVE_INACTIVE_SOCKET_TIMEOUT
          }
        }
      : {})
  },
  assetsBasePath: SERVER
    ? process.env.CLIENT_ASSETS_BASE_PATH
    : getClientConfigValue("ASSETS_BASE_PATH"),
  environmentMode:
    (SERVER
      ? process.env.CLIENT_ENVIRONMENT_MODE
      : getClientConfigValue("ENVIRONMENT_MODE")) || "prod",
  ...((SERVER
    ? process.env.CLIENT_GOOGLE_AD_ENABLED
    : getClientConfigValue("GOOGLE_AD_ENABLED")) === "true"
    ? {
        adverts: {
          scriptSrc: SERVER
            ? process.env.CLIENT_GOOGLE_AD_MANAGER_SCRIPT_SRC
            : getClientConfigValue("GOOGLE_AD_MANAGER_SCRIPT_SRC"),
          adId: SERVER
            ? process.env.CLIENT_GOOGLE_AD_MANAGER_AD_ID
            : getClientConfigValue("GOOGLE_AD_MANAGER_AD_ID"),
          networkCodeAndEnvPrefix: SERVER
            ? process.env.CLIENT_GOOGLE_AD_MANAGER_NETWORK_CODE_AND_ENV_PREFIX
            : getClientConfigValue(
                "GOOGLE_AD_MANAGER_NETWORK_CODE_AND_ENV_PREFIX"
              ),
          fetchMarginPercent: SERVER
            ? process.env.CLIENT_GOOGLE_AD_FETCH_MARGIN_PERCENT
            : getClientConfigValue("GOOGLE_AD_FETCH_MARGIN_PERCENT"),
          renderMarginPercent: SERVER
            ? process.env.CLIENT_GOOGLE_AD_RENDER_MARGIN_PERCENT
            : getClientConfigValue("GOOGLE_AD_RENDER_MARGIN_PERCENT"),
          mobileMarginScaling: SERVER
            ? process.env.CLIENT_GOOGLE_AD_MOBILE_MARGIN_SCALING
            : getClientConfigValue("GOOGLE_AD_MOBILE_MARGIN_SCALING"),
          adPosition: SERVER
            ? parseInt(process.env.CLIENT_GOOGLE_AD_POSITION)
            : parseInt(getClientConfigValue("GOOGLE_AD_POSITION")),
          targetingVicinity: SERVER
            ? parseInt(process.env.CLIENT_GOOGLE_AD_TARGETING_VICINITY)
            : parseInt(getClientConfigValue("GOOGLE_AD_TARGETING_VICINITY")),
          sizeMappings: [
            {
              viewPortSize: [970, 250],
              slotSizes: [[970, 250]]
            },
            {
              viewPortSize: [728, 90],
              slotSizes: [[728, 90]]
            },
            {
              viewPortSize: [0, 0],
              slotSizes: [[320, 100]]
            }
          ]
        }
      }
    : null)
};

export default config;
